import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "exports-table__empty-message" }

import { createFlexTableColumn, type OtFlexTableColumn } from '@1trading/design-system';
import { computed, inject, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import useOpenItem from '@exchange/libs/composables/shared/src/lib/useOpenItem';
import { type ExportItem } from '@exchange/libs/exports/service/src';

import ExportTableRow from './ExportTableRow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportTable',
  props: {
  list: { type: Array as PropType<Array<ExportItem>>, required: true },
  error: { type: String, required: false },
  loading: { type: Boolean, required: true },
  fetchList: { type: Function as PropType<() => Promise<void>>, required: true },
  fetchItem: { type: Function as PropType<(id: string, isTradeItem: boolean) => Promise<void>>, required: true },
  downloadItem: { type: Function as PropType<(id: string, isTradeItem: boolean) => Promise<void>>, required: true },
},
  setup(__props) {



const { t } = useI18n({ useScope: 'global' });
const { isMD, isLG, isXL } = useMQBreakpoints();
const { openItemId, setOpenItemId } = useOpenItem();

const bigScreen = computed(() => isLG.value || isXL.value);

const columns = computed(() => {
  const columnActions: OtFlexTableColumn = {
    ...createFlexTableColumn({
      title: '',
      class: 'action-column',
    }),
  };
  const columnRequested: OtFlexTableColumn = {
    ...createFlexTableColumn({
      title: t('modules.exports.table.headers.requested'),
      class: 'requested-column',
    }),
  };
  const columnType: OtFlexTableColumn = {
    ...createFlexTableColumn({
      title: t('modules.exports.table.headers.type'),
      class: 'type-column',
    }),
  };
  const columnTimeframe: OtFlexTableColumn = {
    ...createFlexTableColumn({
      title: t('modules.exports.table.headers.timeframe'),
      class: 'timeframe-column',
    }),
  };
  const columnExpiry: OtFlexTableColumn = {
    ...createFlexTableColumn({
      title: t('modules.exports.table.headers.expiry'),
      class: 'expiry-column',
    }),
  };

  const toShow = [columnRequested, columnType, columnActions];

  if (isMD.value) {
    toShow.splice(2, 0, columnExpiry);
  } else if (bigScreen.value) {
    toShow.splice(2, 0, columnTimeframe, columnExpiry);
  }

  return toShow;
});

const utcToLocal = inject<(utcDateString: string | Date | number, formatString?: string) => string>('utcToLocal');

return (_ctx: any,_cache: any) => {
  const _component_ot_async_grid_table = _resolveComponent("ot-async-grid-table")!

  return (_openBlock(), _createBlock(_component_ot_async_grid_table, {
    class: "exports-table full-width",
    "header-class": "exports-table__header",
    columns: columns.value,
    data: __props.list,
    error: __props.error,
    loading: __props.loading,
    "with-empty-message": true,
    narrow: true,
    retry: __props.fetchList
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
        return (_openBlock(), _createBlock(ExportTableRow, {
          id: item.id,
          key: item.id,
          item: item,
          collapsed: _unref(openItemId) !== item.id,
          "get-local-time": _unref(utcToLocal),
          "fetch-item": __props.fetchItem,
          "download-item": __props.downloadItem,
          onClick: ($event: any) => (_unref(setOpenItemId)(item.id))
        }, null, 8, ["id", "item", "collapsed", "get-local-time", "fetch-item", "download-item", "onClick"]))
      }), 128))
    ]),
    _: 2
  }, [
    (!__props.list.length)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('modules.exports.table.empty')), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["columns", "data", "error", "loading", "retry"]))
}
}

})